import { CommonModule, NgClass } from '@angular/common';
import { Component, ElementRef, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { TooltipModule } from 'primeng/tooltip';
import { Subscription } from 'rxjs';
import { AiInsightsService } from '../../services/ai-insights.service';
import { UserRoleService } from '../../services/user-role.service';
import { LogoComponent } from '../../svg/logo/logo.component';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    templateUrl: './sidebar.component.html',
    imports: [LogoComponent, NgClass, CommonModule, RouterLink, RouterLinkActive, TooltipModule]
})
export class SidebarComponent implements OnInit {
    public isOpen = false;
    public loginDisplay = false;
    public UserRoles = inject(UserRoleService);
    public aiInsightsService = inject(AiInsightsService);
    private routerSub!: Subscription;

    constructor(private authService: MsalService, private router: Router) { }

    ngOnInit() {
        this.aiInsightsService.startHealthMonitoring();
        this.routerSub = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd && this.isMobile()) {
                this.closeSidebar();
            }
        });
    }

    @ViewChild('sidebar') sidebar!: ElementRef<any>;

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        if (this.isMobile() && this.isOpen) {
            const target = event.target as HTMLElement;
            const clickedInside = this.sidebar.nativeElement.contains(target);
            if (!clickedInside && !target.classList.contains('burgerMenu')) {
                this.closeSidebar();
            }
        }
    }

    isMobile(): boolean {
        return window.innerWidth <= 768;
    }

    closeSidebar() {
        this.isOpen = false;
    }

    logout(popup?: boolean) {
        this.loginDisplay = true;
        if (popup) {
            this.authService.logoutPopup({
                mainWindowRedirectUri: '/',
            });
        } else {
            this.authService.logoutRedirect();
        }
    }
}
